import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import TrueFalseIcon from '../../../../components/common/TrueFalseIcon';
import EditButton from '../../../elements/EditButton';
import Search from '../../../elements/Search';
import Paginator from '../../../elements/paginator';
import axios from '../../../services/MyAxios';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import { CASINO_GAME_CREATORS, CASINO_GAME_CREATORS_GAME_EDIT } from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function GameCreatorShow() {
    const [gameCreator, setGameCreator] = useState({
        name: '',
        restrictedCountries: [],
        games: [],
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');

    const { id } = useParams();
    const apiUrl = `/crea/casino/api/game-creators/${id}`;
    const history = useHistory();
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

    const getGameCreator = (page = 1) => {
        if (filter.length !== 0 && filter.length < 3) {
            return;
        }

        let gameCreatorUrl = apiUrl;

        if (page !== 1) {
            gameCreatorUrl += `?page=${page}`;
        }
        axios
            .get(gameCreatorUrl, {
                params: {
                    filter,
                },
            })
            .then((response) => {
                setGameCreator(response.data);
                setCurrentPage(response.data.games.current_page);
                setLastPage(response.data.games.last_page);
            })
            .catch(() => {
                history.push({
                    pathname: CASINO_GAME_CREATORS,
                });
            });
    };

    useEffect(() => {
        getGameCreator();
    }, []);

    useEffect(() => {
        getGameCreator();
    }, [filter]);

    const filterTable = (value) => {
        setFilter(value);
    };

    return (
        <div>
            <div className="card">
                <div className="card-header">{gameCreator.name} games</div>
                <div className="card-body table-responsive">
                    <div className="d-flex justify-content-between">
                        <Search filterTable={filterTable} />
                    </div>
                    <div className="search-info">Min. 3 chars to search</div>
                    {gameCreator.games.data?.length > 0 ? (
                        <div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Game name</th>
                                        <th>Is desktop</th>
                                        <th>Is mobile</th>
                                        <th>Is disabled</th>
                                        <th>Is deleted</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gameCreator.games.data?.map((game) => (
                                        <tr key={game.id}>
                                            <td>{game.name}</td>
                                            <td>
                                                <TrueFalseIcon status={game.is_desktop} />
                                            </td>
                                            <td>
                                                <TrueFalseIcon status={game.is_mobile} />
                                            </td>
                                            <td>
                                                <TrueFalseIcon status={game.is_disabled} />
                                            </td>
                                            <td>
                                                <TrueFalseIcon status={game.is_deleted} />
                                            </td>
                                            <td>
                                                <EditButton
                                                    url={replaceUrlParams(CASINO_GAME_CREATORS_GAME_EDIT, {
                                                        gameCreatorId: id,
                                                        gameId: game.id,
                                                    })}
                                                    permissions={[CRM_PERMISSION.GAME_EDIT]}
                                                    key="view"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getGameCreator} />
                        </div>
                    ) : (
                        <p>Cannot find any games for this game creator.</p>
                    )}
                </div>
            </div>
            <div className="card">
                <div className="card-header">Restricted countries</div>
                <div className="card-body table-responsive">
                    <div>
                        {gameCreator.restrictedCountries.length > 0 ? (
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gameCreator.restrictedCountries.map((countryCode) => (
                                        <tr key={countryCode}>
                                            <td>{regionNames.of(countryCode)}</td>
                                            <td>{countryCode}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>This game creator does not have any restricted country.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GameCreatorShow;
